/// <amd-module name="Dashboards/ConfigHost/ConfigHostProps" />
import { ConfigProps } from "Dashboards/WidgetContracts/Internal/ConfigProps";

/**
 * Contract for Rendering Widget Configuration Experience - A union of Configuration and Runtime properties.
 */
export interface ConfigHostProps extends ConfigProps {}
